import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useBreakpointUp } from '@travel-frontend/core';
import { Trans, useTranslation } from 'next-i18next';
import { useState } from 'react';
import { ReviewCategory } from '../../../../../../components/HotelDetailsOverlay/components/RatingSection/components/Reviews/components/ReviewCategory/index.js';
import { SummaryStatement } from '../../../../../../components/HotelDetailsOverlay/components/RatingSection/components/Reviews/components/SummaryStatement.js';
import { TabPanel } from '../../../../../../components/HotelDetailsOverlay/components/RatingSection/components/Reviews/components/TabPanel.js';
import { useRating } from '../../../../../../components/HotelDetailsOverlay/hooks/useRating.js';
import { TRAVELLER_TYPE_ALL } from '../../../../../../components/HotelDetailsOverlay/models.js';
import { HeadlineMedium, ParagraphMedium, Stack, Tab, Tabs } from '../../../../../../primitives/index.js';
export const Reviews = ({
  reviews,
  summaryText
}) => {
  const {
    t
  } = useTranslation();
  const mdUp = useBreakpointUp('md');
  const formatScore = useRating();
  const [activeTab, setActiveTab] = useState(0);
  if (!reviews || reviews.length === 0) {
    return null;
  }
  return _jsxs(Stack, {
    spacing: "small",
    children: [_jsx(HeadlineMedium, {
      children: t('hotelDetailsOverlay:ratingSection.reviews.title')
    }), _jsxs(Stack, {
      children: [reviews.length > 1 && _jsx(Tabs, {
        value: activeTab,
        onChange: setActiveTab,
        children: reviews.map(({
          travellerType,
          travellerTypeTranslation
        }) => _jsx(Tab, {
          label: travellerTypeTranslation,
          size: "small"
        }, travellerType))
      }), reviews.map(({
        travellerType,
        travellerTypeTranslation,
        score,
        reviewPercent,
        categories
      }, index) => {
        const {
          scoreFormatted,
          scoreMax
        } = formatScore(score);
        return _jsx(TabPanel, {
          hidden: index !== activeTab,
          children: _jsxs(Stack, {
            children: [_jsxs(SummaryStatement, {
              children: [_jsx(ParagraphMedium, {
                children: _jsx(Trans, {
                  i18nKey: "hotelDetailsOverlay:ratingSection.reviews.summaryStatement",
                  values: {
                    score: `${scoreFormatted} / ${scoreMax}`,
                    travellerType: travellerTypeTranslation,
                    percent: `${reviewPercent}%`
                  },
                  components: {
                    bold: _jsx("b", {}),
                    highlight: _jsx("q", {})
                  },
                  tOptions: {
                    interpolation: {
                      escapeValue: false
                    }
                  }
                })
              }), travellerType === TRAVELLER_TYPE_ALL && summaryText && _jsx(ParagraphMedium, {
                as: "q",
                fontStyle: "italic",
                children: summaryText
              })]
            }), Array.isArray(categories) && categories.length > 0 && _jsx(Stack, {
              spacing: mdUp ? 'medium' : 'large',
              divider: mdUp,
              children: categories?.map(({
                id,
                caption,
                score,
                reviewCount,
                statements
              }) => _jsx(ReviewCategory, {
                title: caption,
                score: score,
                reviewCount: reviewCount,
                statements: statements
              }, id))
            })]
          })
        }, travellerType);
      })]
    })]
  });
};